import React from "react";
import { CheckIcon } from "lucide-react";
import { STEPS } from "../hooks/useConfigurator";
interface ConfiguratorHeaderProps {
  step: number;
  maxReached: number;
  onStepClick: (index: number) => void;
  onQuit: () => void;
}
export function ConfiguratorHeader({
  step,
  maxReached,
  onStepClick,
  onQuit
}: ConfiguratorHeaderProps) {
  return <header className="sticky top-0 z-30 border-b border-line bg-paper" data-id="element-15" data-mp="s1373s6b7qzg">
      <div className="flex h-[52px] items-stretch" data-id="element-16" data-mp="1oo7z466khotw">
        <div className="flex shrink-0 items-center gap-3 border-r border-line px-5 md:px-8" data-id="element-17" data-mp="1jqept49ywepe">
          <span className="text-2xl font-bold tracking-tight" data-id="element-18" data-mp="1fot8n6qehe9e">
            Affective<sup className="text-sm" data-id="element-19" data-mp="1fn02dsjp8w1x">+</sup>
          </span>
          <span className="hidden whitespace-nowrap text-sm font-bold text-muted xl:inline" data-id="element-20" data-mp="1aqjff1o8knqf">Configurateur</span>
        </div>

        <nav aria-label="Étapes de configuration" className="flex min-w-0 flex-1 items-stretch overflow-x-auto" data-id="element-21" data-mp="4b8wziddkgiw">
          <ol className="flex flex-1 items-stretch" data-id="element-22" data-mp="3vi1yknc2yhny">
            {STEPS.map((label, i) => {
            const isActive = i === step;
            const isDone = i < step || i <= maxReached && i !== step;
            const reachable = i <= maxReached;
            return <li key={label} className="flex flex-1 items-stretch border-r border-line last:border-r-0" data-id="element-23" data-mp="14ooxee21en5v" data-mpi={i}>
                  <button type="button" onClick={() => onStepClick(i)} disabled={!reachable} aria-current={isActive ? "step" : undefined} className={`flex w-full items-center justify-center gap-2 whitespace-nowrap px-3 text-sm font-bold transition-colors duration-150 ease-out ${isActive ? "bg-ink text-paper" : reachable ? "text-ink hover:bg-mist" : "cursor-not-allowed text-muted/60"}`} data-id="element-24" data-mp="19mgsti1w4ret">
                    <span className={`flex h-5 w-5 items-center justify-center rounded-full text-[11px] ${isActive ? "bg-mint text-ink" : isDone ? "bg-ink text-paper" : "border border-current"}`} data-id="element-25" data-mp="2ipbjimtlb8cz">
                      {isDone && !isActive ? <CheckIcon size={12} strokeWidth={3} data-id="element-26" data-mp="24yga99f6ip8v" /> : i + 1}
                    </span>
                    <span className={isActive ? "inline" : "hidden md:inline"} data-id="element-27" data-mp="31nxle3wxl3hy">{label}</span>
                  </button>
                </li>;
          })}
          </ol>
        </nav>

        <button type="button" onClick={onQuit} className="hidden shrink-0 items-center border-l border-line px-6 text-sm font-bold underline-offset-4 transition-colors duration-150 ease-out hover:bg-mist hover:underline sm:flex" data-id="element-28" data-mp="2sm6it7xotcsb">
          Recommencer
        </button>
      </div>
    </header>;
}